var _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPositiveResponseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 145 145",
    fill: "white",
    fillOpacity: 0.6,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, -17)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4999 105.096C90.5023 105.096 105.096 90.5025 105.096 72.5001C105.096 54.4977 90.5023 39.9038 72.4999 39.9038C54.4974 39.9038 39.9036 54.4977 39.9036 72.5001C39.9036 90.5025 54.4974 105.096 72.4999 105.096ZM112.766 72.5001C112.766 94.7384 94.7381 112.766 72.4999 112.766C50.2616 112.766 32.2339 94.7384 32.2339 72.5001C32.2339 50.2618 50.2616 32.2341 72.4999 32.2341C94.7381 32.2341 112.766 50.2618 112.766 72.5001Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4802 78.9383C61.5883 77.8008 59.9432 77.6017 58.8057 78.4936C57.6681 79.3855 57.469 81.0306 58.3609 82.1682C62.0141 86.8274 66.9085 89.2104 72.8256 89.2104C78.7945 89.2104 83.5302 86.7771 86.7481 82.0196C87.5579 80.8223 87.2438 79.1951 86.0465 78.3853C84.8492 77.5754 83.2221 77.8895 82.4122 79.0869C80.183 82.3826 77.0823 83.9758 72.8256 83.9758C68.517 83.9758 65.1413 82.3323 62.4802 78.9383Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1729 63.8675C81.3388 64.7621 79.9375 64.8112 79.0428 63.9771C78.1482 63.1431 78.0991 61.7417 78.9332 60.8471C80.4738 59.1946 82.4786 58.3692 84.749 58.4178C86.891 58.4244 88.7655 59.2612 90.2353 60.857C91.0638 61.7567 91.0062 63.1577 90.1065 63.9863C89.2068 64.8149 87.8058 64.7573 86.9772 63.8576C86.3375 63.1629 85.636 62.8498 84.6952 62.8466C83.6313 62.8239 82.8433 63.1484 82.1729 63.8675Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.013 63.8675C57.179 64.7621 55.7776 64.8112 54.883 63.9771C53.9884 63.1431 53.9393 61.7417 54.7733 60.8471C56.3139 59.1946 58.3187 58.3692 60.5892 58.4178C62.7312 58.4244 64.6057 59.2612 66.0754 60.857C66.904 61.7567 66.8464 63.1577 65.9467 63.9863C65.047 64.8149 63.6459 64.7573 62.8174 63.8576C62.1776 63.1629 61.4762 62.8498 60.5353 62.8466C59.4715 62.8239 58.6834 63.1484 58.013 63.8675Z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: 127,
    textAnchor: "middle",
    fontSize: 20,
    fontWeight: "bold",
    fontFamily: "Arial, sans-serif"
  }, "\n        Helpful\n    ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositiveResponseButton);
export default __webpack_public_path__ + "static/media/Positive Response Button.774219bc8a6f2fa84d5483a0db1e563f.svg";
export { ForwardRef as ReactComponent };